export default class PartnersClient {
    constructor(apiClient) {
        this.baseURI = '/v3/partners';
        this.apiClient = apiClient;
        this.postPartner = this.postPartner.bind(this);
        this.putPartner = this.putPartner.bind(this);
        this.getPartners = this.getPartners.bind(this);
        this.getPartner = this.getPartner.bind(this);
        this.getPartnerVersion = this.getPartnerVersion.bind(this);
        this.getPartnerVersions = this.getPartnerVersions.bind(this);
        this.postPartnerCountry = this.postPartnerCountry.bind(this);
        this.putPartnerCountry = this.putPartnerCountry.bind(this);
        this.deletePartnerCountry = this.deletePartnerCountry.bind(this);
        this.postPartnerAgent = this.postPartnerAgent.bind(this);
        this.getPartnerAgents = this.getPartnerAgents.bind(this);
        this.getPartnerAgentCounts = this.getPartnerAgentCounts.bind(this);
        this.postPartnerSpecialization = this.postPartnerSpecialization.bind(this);
        this.deletePartnerSpecialization = this.deletePartnerSpecialization.bind(this);
        this.postPartnerExclusion = this.postPartnerExclusion.bind(this);
        this.deletePartnerExclusion = this.deletePartnerExclusion.bind(this);
        this.postPartnerAvailability = this.postPartnerAvailability.bind(this);
        this.putPartnerAvailability = this.putPartnerAvailability.bind(this);
        this.getPartnerAvailability = this.getPartnerAvailability.bind(this);
        this.getPartnerAvailabilityVersion = this.getPartnerAvailabilityVersion.bind(this);
        this.getPartnerAvailabilityVersions = this.getPartnerAvailabilityVersions.bind(this);
        this.deletePartnerAvailability = this.deletePartnerAvailability.bind(this);
        this.getPartnerAvailabilities = this.getPartnerAvailabilities.bind(this);
        this.postPartnerSearch = this.postPartnerSearch.bind(this);
        this.postPartnerNoCompete = this.postPartnerNoCompete.bind(this);
        this.deletePartnerNoCompete = this.deletePartnerNoCompete.bind(this);
        this.postPartnerAvailabilitySearch = this.postPartnerAvailabilitySearch.bind(this);
        this.getSalesRecordingTotalsForMonth = this.getSalesRecordingTotalsForMonth.bind(this);
        this.getPartnerNames = this.getPartnerNames.bind(this);
    }
    postPartner(data, config) {
        return this.apiClient.post(this.baseURI, data, config);
    }
    putPartner(id, data, config) {
        return this.apiClient.put(`${this.baseURI}/${id}`, data, config);
    }
    putPartnerProfile(id, data, config) {
        return this.apiClient.put(`${this.baseURI}/${id}/profiles`, data, config);
    }
    putPartnerStatus(id, data, config) {
        return this.apiClient.put(`${this.baseURI}/${id}/status`, data, config);
    }
    putPartnerBillingAddress(id, data, config) {
        return this.apiClient.put(`${this.baseURI}/${id}/billing_address`, data, config);
    }
    getPartners(config) {
        return this.apiClient.get(this.baseURI, config);
    }
    getPartner(id, config) {
        return this.apiClient.get(`${this.baseURI}/${id}`, config);
    }
    getPartnerVersion(id, updateId, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/versions/${updateId}`, config);
    }
    getPartnerVersions(id, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/versions`, config);
    }
    postPartnerCountry(id, data, config) {
        return this.apiClient.post(`${this.baseURI}/${id}/countries`, data, config);
    }
    putPartnerCountry(id, code, data, config) {
        return this.apiClient.put(`${this.baseURI}/${id}/countries/${code}`, data, config);
    }
    deletePartnerCountry(id, code, config) {
        return this.apiClient.delete(`${this.baseURI}/${id}/countries/${code}`, config);
    }
    postPartnerAgent(id, data, config) {
        return this.apiClient.post(`${this.baseURI}/${id}/agents`, data, config);
    }
    getPartnerAgents(id, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/agents`, config);
    }
    getPartnerAgentCounts(id, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/agent_counts`, config);
    }
    postPartnerSpecialization(id, name, config) {
        return this.apiClient.post(`${this.baseURI}/${id}/specializations/${name}`, config);
    }
    deletePartnerSpecialization(id, name, config) {
        return this.apiClient.delete(`${this.baseURI}/${id}/specializations/${name}`, config);
    }
    postPartnerExclusion(id, name, config) {
        return this.apiClient.post(`${this.baseURI}/${id}/exclusions/${name}`, config);
    }
    deletePartnerExclusion(id, name, config) {
        return this.apiClient.delete(`${this.baseURI}/${id}/exclusions/${name}`, config);
    }
    /*
    getPartnerMessageTemplates(id: string, config?: AxiosRequestConfig) {
      return this.apiClient.get<Agent[]>(`${this.baseURI}/${id}/message_templates/`, config);
    }
  
    getPartnerTripMatches(id: string, config?: AxiosRequestConfig) {
      return this.apiClient.get<Agent[]>(`${this.baseURI}/${id}/trip_matches/`, config);
    }
  
    getPartnerReviews(id: string, config?: AxiosRequestConfig) {
      return this.apiClient.get<Agent[]>(`${this.baseURI}/${id}/reviews/`, config);
    }
    */
    postPartnerAvailability(id, data, config) {
        return this.apiClient.post(`${this.baseURI}/${id}/partner_availabilities`, data, config);
    }
    putPartnerAvailability(id, avId, data, config) {
        return this.apiClient.put(`${this.baseURI}/${id}/partner_availabilities/${avId}`, data, config);
    }
    getPartnerAvailability(id, avId, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/partner_availabilities/${avId}`, config);
    }
    getPartnerAvailabilityVersion(id, avId, avUpdateId, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/partner_availabilities/${avId}/versions/${avUpdateId}`, config);
    }
    getPartnerAvailabilityVersions(id, avId, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/partner_availabilities/${avId}/versions`, config);
    }
    deletePartnerAvailability(id, avId, config) {
        return this.apiClient.delete(`${this.baseURI}/${id}/partner_availabilities/${avId}`, config);
    }
    getPartnerAvailabilities(id, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/partner_availabilities`, config);
    }
    postPartnerSearch(data, config) {
        return this.apiClient.post('/v3/partner_searches', data, config);
    }
    postPartnerNoCompete(partnerId, noCompetePartnerId, config) {
        return this.apiClient.post(`${this.baseURI}/${partnerId}/no_competes/${noCompetePartnerId}`, config);
    }
    deletePartnerNoCompete(partnerId, noCompetePartnerId, config) {
        return this.apiClient.delete(`${this.baseURI}/${partnerId}/no_competes/${noCompetePartnerId}`, config);
    }
    postPartnerAvailabilitySearch(data, config) {
        return this.apiClient.post('/v3/partner_availability_searches', data, config);
    }
    getPartnerNames(config) {
        return this.apiClient.get('/v3/partner_names', config);
    }
    getSalesRecordingTotalsForMonth(config) {
        return this.apiClient.get('/v3/partners/sales_recording_totals', config);
    }
}
